module.exports = __webpack_public_path__ + "static/img/top-1.c4cbf5b0.png";